import { formatTime } from "./weekUtils";

export var BLOCK_MINUTES = 30;

// Defaults used until an admin saves their own in Admin -> Court Booking.
export var DEFAULT_SETTINGS = {
  openTime: "08:00",
  closeTime: "22:00",
  pricePence: 400,          // per 30-minute block, charged to non-members only
  gameJoinFeePence: 400,    // flat fee for a non-member to join someone's open game
  maxMinutes: 120,
  minMinutesMember: 30,
  minMinutesNonMember: 60,  // non-members are charged for at least an hour
  advanceDays: 14,
  holdMinutes: 10,          // how long an unpaid non-member booking holds the slot
  floodlightsFromMin: 1440, // minutes after midnight the lights come on; 1440 = no floodlight charge
  floodlightRatePence: 200, // per hour, charged to members AND non-members (never admins)
};

export function parseDateKey(key) {
  var p = key.split("-");
  return new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
}

// Half-hour blocks of a booking that fall on or after the lights-on time.
export function floodlightBlocks(startMin, endMin, lightsFromMin) {
  var n = 0;
  for (var m = startMin; m < endMin; m += BLOCK_MINUTES) {
    if (m >= lightsFromMin) n++;
  }
  return n;
}

export function floodlightFee(ratePencePerHour, litBlocks) {
  return Math.round((ratePencePerHour || 0) * litBlocks / 2);
}

// A recurring club session reserved by an admin. `courts` empty/missing = all courts.
export function blockApplies(block, dateKey, court, minute) {
  if (!block.active) return false;
  if (parseDateKey(dateKey).getDay() !== block.dayOfWeek) return false;
  if (block.fromDate && dateKey < block.fromDate) return false;
  if (block.toDate && dateKey > block.toDate) return false;
  if ((block.excludedDates || []).indexOf(dateKey) !== -1) return false;
  if (block.courts && block.courts.length && block.courts.indexOf(court) === -1) return false;
  return minute >= block.startMin && minute < block.endMin;
}

export function timeToMin(t) {
  var parts = (t || "00:00").split(":");
  return (parseInt(parts[0], 10) || 0) * 60 + (parseInt(parts[1], 10) || 0);
}

export function minToTime(m) {
  return String(Math.floor(m / 60)).padStart(2, "0") + ":" + String(m % 60).padStart(2, "0");
}

export function formatMin(m) {
  return formatTime(minToTime(m));
}

export function formatPence(p) {
  return "£" + (p / 100).toFixed(2);
}

export function slotId(venueId, date, court, startMin) {
  return venueId + "_" + date + "_" + court + "_" + startMin;
}

export function slotIdsFor(venueId, date, court, startMin, endMin) {
  var ids = [];
  for (var m = startMin; m < endMin; m += BLOCK_MINUTES) ids.push(slotId(venueId, date, court, m));
  return ids;
}

// A pending (unpaid) hold that has run out no longer blocks anyone else.
export function isSlotTaken(slot, nowMs) {
  if (!slot) return false;
  if (slot.status === "pending" && typeof slot.holdUntil === "number" && slot.holdUntil < nowMs) return false;
  return true;
}

export function priceFor(pricePence, startMin, endMin) {
  return pricePence * ((endMin - startMin) / BLOCK_MINUTES);
}

// Longest booking that can start at `startMin` on a court: runs through free
// blocks, stops at closing time, and is capped at the max booking length.
// `isBlocked(minute)` (optional) lets recurring club sessions count as taken too.
export function maxLengthFrom(slotsById, venueId, date, court, startMin, closeMin, maxMinutes, nowMs, isBlocked) {
  var len = 0;
  for (var m = startMin; m < closeMin && len < maxMinutes; m += BLOCK_MINUTES) {
    if (isSlotTaken(slotsById[slotId(venueId, date, court, m)], nowMs)) break;
    if (isBlocked && isBlocked(m)) break;
    len += BLOCK_MINUTES;
  }
  return len;
}
